module.exports = __webpack_public_path__ + "feedback_negative.631068707436c66f0aa64bd5659ccbc1.svg";